import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const TabContainer = styled("div")<{ current?: boolean }>`
    align-items: center;
    border-bottom-color: ${(props) => props.theme.palette.primary.main};
    border-bottom-style: solid;
    border-bottom-width: ${(props) => (props.current ? "2px" : 0)};
    display: flex;
    height: 50px;
    justify-content: center;
    min-width: 115px;
    padding: 0 8px;

    ${(props) => props.theme.breakpoints.down("desktop")} {
        flex: 1 1 0%;
        min-width: auto;
    }
`;

interface TabProps {
    icon: FunctionComponent<SvgIconProps>;
    text: string;
    current?: boolean;
}

const Text = styled("div")`
    font-size: 14px;
    margin-left: ${(props) => `${props.theme.spacing.unit}px`};
`;

const Tab: FunctionComponent<TabProps> = ({ icon: Icon, text, current }) => {
    return (
        <TabContainer current={current}>
            <Icon style={{ height: "15px" }} />
            <Text>{text}</Text>
        </TabContainer>
    );
};

const Container = styled("div")`
    background-color: #e9e9e9;
    display: flex;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        padding-left: 56px;
    }
`;

interface TopBar {
    tabs: Array<{ name: string; icon: FunctionComponent<SvgIconProps> }>;
    current?: number | null;
}

const TopBar: FunctionComponent<TopBar> = ({ tabs, current }) => {
    return (
        <Container>
            {tabs.map((m, index) => (
                <Tab key={m.name} icon={m.icon} text={m.name} current={index === current} />
            ))}
        </Container>
    );
};

export default TopBar;
